import { createPortal } from 'react-dom';
import { useMediaToastsStore } from '../../../../redux/mediaManagement/mediaManagementHooks';
import { Icon } from './Icon';

const ICONS = { success: 'check_circle', error: 'error', info: 'info' } as const;

/** Media Management toasts: cards top-right, and pills bottom-center (e.g. "Sync triggered"). */
export function MediaToasts() {
  const { toasts, dismiss } = useMediaToastsStore();
  if (!toasts.length) return null;
  const corner = toasts.filter((t) => t.placement === 'corner');
  const bottom = toasts.filter((t) => t.placement === 'bottom');

  return createPortal(
    <>
      {corner.length > 0 && (
        <div className="mm-toasts" aria-live="polite">
          {corner.map((t) => (
            <div key={t.id} className={`mm-toast mm-${t.type}`}>
              <Icon name={ICONS[t.type]} />
              <span>{t.message}</span>
            </div>
          ))}
        </div>
      )}
      {bottom.length > 0 && (
        <div className="mm-pill-toasts" aria-live="polite">
          {bottom.map((t) => (
            <div key={t.id} className={`mm-pill-toast mm-${t.type}`}>
              <span className="mm-pill-text">{t.message}</span>
              <button type="button" className="mm-pill-close" onClick={() => dismiss(t.id)} aria-label="Dismiss">
                <Icon name="close" />
              </button>
            </div>
          ))}
        </div>
      )}
    </>,
    document.body,
  );
}
